import {newAxios} from './index'
const cus = true

export const Req_GetArticleList = function (data) {
  return newAxios({
    url: '/i/tenant/finance/article/list',
    data
  })()
}

export const Req_GetArticle = function (data) {
  return newAxios({
    url:`/i/tenant/finance/article/view/${data}`
  })()
}

export const Req_SearchArticle = function (data) {
  return newAxios({
    url:`/i/tenant/finance/article/search`,
    data
  })()
}

export const Req_SearchKeyword = function (data) {
  return newAxios({
    url:`/i/tenant/finance/article/keyword/search`,
    data
  })()
}

export const Req_GetVerticalList = function (data) {
  return newAxios({
    url:`/i/tenant/finance/article/group/list`,
    data
  })()
}

export const Req_GetAskList = function (data) {
  return newAxios({
    url:`/i/tenant/finance/ask/list`,
    data
  })()
}

export const Req_SubmitAsk = function (data) {
  const url = data.askId ? `/i/tenant/finance/ask/update` : `/i/tenant/finance/ask/add`
  return newAxios({
    url,
    data
  },'json')()
}

export const Req_DeleteAsk = function (data) {
  return newAxios({
    url:`/i/tenant/finance/ask/delete/${data}    `
  })()
} 

export const Req_GetAskDetail = function (data) {
  return newAxios({
    url:`/i/tenant/finance/ask/info/${data}`
  })()
}

export const Req_SubmitAskReplay = function (data) {
  console.log(data)
  const url = data.replyId ? '/i/tenant/finance/ask/replay/update' : '/i/tenant/finance/ask/replay/add'
  return newAxios({
    url,
    data
  },'json')()
}

export const Req_UpdateAskReplay = function (data) {
  return newAxios({
    url:`/i/tenant/finance/ask/replay/update`,
    data
  },'json')()
}

export const Req_DeleteAskReplay = function (data) {
  return newAxios({
    url:`/i/tenant/finance/ask/replay/delete/${data}`
  })()
}

export const Req_SolveAsk = function (data) {
  return newAxios({
    url:`/i/tenant/finance/ask/solve/${data}`
  })()
}

export const Req_ShareAsk = function (data) {
  return newAxios({
    url:`/i/tenant/finance/ask/shared`,
    data
  },'json')()
}

export const Req_UnShardAsk = function (data) {
  return newAxios({
    url:`/i/tenant/finance/ask/unShard/${data}`,
  })()
}

export const Req_RevocationAskStatus = function (data) {
  return newAxios({
    url:`/i/tenant/finance/ask/revocation/status/${data}`,
  })()
}

export const Req_GetCatalogVerticalList = function(data) {
  return newAxios({
    url:`/i/tenant/finance/ask/catalog/vertical/list`,
    data
  })()
}

//需求及bug列表
export const Req_GetDemandList = function(data) {
  return newAxios({
    url:`/i/tenant/system/demand/list`,
    data
  })()
}


// WEBPACK FOOTER //
// ./src/request/helpCenter.js